module.exports = __webpack_public_path__ + "static/media/sw14.edf684f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/street wear/sw14.jpg
// module id = 537
// module chunks = 0